import { render, staticRenderFns } from "./KaspiPay.vue?vue&type=template&id=21856248&scoped=true&"
import script from "./KaspiPay.vue?vue&type=script&lang=js&"
export * from "./KaspiPay.vue?vue&type=script&lang=js&"
import style0 from "./KaspiPay.vue?vue&type=style&index=0&id=21856248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21856248",
  null
  
)

export default component.exports